import request from './requestWrapper';

// Types
import {PaginationType} from '../types/sharedTypes';
import {ContainerShipmentType} from '../types/containerShipmentTypes';

function getParams() {
  return request({
    url: 'containerShipment/getParams',
    method: 'GET',
  });
}
function getAll(data: PaginationType) {
  return request({
    url: 'containerShipment/getAllPaginated',
    method: 'POST',
    data: data
  });
}
function getAllContainersInProcess() {
  return request({
    url: 'containerShipment/getAllShimpmentsInProcess',
    method: 'GET'
  });
}
function getSchedule(startDate: Date, endDate: Date) {
  return request({
    url: 'containerShipment/getSchedule',
    method: 'POST',
    data: { startDate, endDate },
  });
}
function getByDownloadDate(downloadDate: Date) {
  return request({
    url: 'containerShipment/getByDownloadDate',
    method: 'POST',
    data: { downloadDate },
  });
}
function setDownloadShimpmentDate(shipmentId: string, downloadDate: Date | null) {
  return request({
    url: 'containerShipment/setDownloadShimpmentDate',
    method: 'PUT',
    data: { shipmentId, downloadDate },
  });
}
function update(containerShipment: ContainerShipmentType) {
  return request({
    url: 'containerShipment/update',
    method: 'PUT',
    data: containerShipment,
  });
}
function recalculateShipmentQuantities(shipmentId: string) {
  return request({
    url: 'containerShipment/recalculateShipmentQuantities',
    method: 'POST',
    data: { shipmentId },
  });
}
function downloadScheduleFile(startDate: Date, endDate: Date) {
  return request({
    url: 'containerShipment/downloadSchedule',
    method: 'POST',
    data: { startDate, endDate },
  });
}

export default {
  getParams, getAll, getAllContainersInProcess, getSchedule, getByDownloadDate,
  setDownloadShimpmentDate, update, recalculateShipmentQuantities, downloadScheduleFile
};
